export default __webpack_public_path__ + "static/media/data-properties-difference.5e437f03.PNG";